import Steps from '@/modules/steps/components/Steps'

const HomeOurProcess = () => {
  return <Steps />
}

export default HomeOurProcess
